import { createSlice } from "@reduxjs/toolkit";
import { IContactUsInitialState } from "@/types/contactus.types";
import { insertLead, mobileSubscribe } from "@/services/blog.services";

const initialState: IContactUsInitialState = {
  loading: false,
  error: "",
};

const contactUsSlice = createSlice({
  name: "contactUs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(insertLead.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertLead.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(mobileSubscribe.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(mobileSubscribe.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(mobileSubscribe.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default contactUsSlice.reducer;
